if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, MediaUpload, RichText } = window.wp.editor;
    const { PanelBody, Button, TextControl, SelectControl } = window.wp.components;

    function getFields(tourType) {
        return tourType === 'hike' ? [
            { name: 'duration', label: 'Trajanje', placeholder: '5–8 sati' },
            { name: 'distance', label: 'Duljina', placeholder: '15 km' },
            { name: 'difficulty', label: 'Zahtjevnost', placeholder: 'Zahtjevna' }
        ] : [
            { name: 'duration', label: 'Trajanje', placeholder: '4,5 sati' },
            { name: 'price', label: 'Cijena', placeholder: '75 € po osobi · min. 3 osobe' }
        ];
    }

    function renderCard(attributes, editing, setAttributes) {
        const { tourType, image, alt, link } = attributes;
        const CardTag = !editing && link ? 'a' : 'div';

        function renderText(tagName, name, placeholder, className) {
            if (editing) {
                return <RichText tagName={ tagName } className={ className } value={ attributes[name] } placeholder={ placeholder } onChange={ value => setAttributes({ [name]: value }) } />;
            }
            return <RichText.Content tagName={ tagName } className={ className } value={ attributes[name] } />;
        }

        return (
            <CardTag className="card tour-card" href={ !editing && link ? link : undefined }>
                <div className="tour-card-image">
                    <div
                        className={ 'img cover-image bg-dark' + (editing ? '' : ' lozad') }
                        style={ editing && image ? { backgroundImage: `url(${image})` } : undefined }
                        data-background-image={ !editing && image ? image : undefined }
                        role={ image && alt ? 'img' : undefined }
                        aria-label={ image && alt ? alt : undefined }
                        aria-hidden={ image && alt ? undefined : true }
                    ></div>
                </div>
                <div className="card-body">
                    { renderText('span', 'eyebrow', '01 / SAORSA TURA', 'eyebrow') }
                    { renderText('h3', 'title', tourType === 'hike' ? 'Staza sedam slapova' : 'Vrhi Ćićarije') }
                    <div className="tour-card-highlight">
                        { renderText('span', 'highlightLabel', 'Izdvojeno') }
                        { renderText('strong', 'highlight', tourType === 'hike' ? 'Rijeka Mirna / sedam slapova / Kotli' : 'Ćićarija / Korita / Brgudac') }
                    </div>
                    <div className="tour-card-summary">
                        <div className="row gx-4 gy-2">
                            { getFields(tourType).filter(field => editing || attributes[field.name]).map(field => (
                                <div key={ field.name } className="col-auto">
                                    { renderText('span', field.name + 'Label', field.label) }
                                    { renderText('strong', field.name, field.placeholder) }
                                </div>
                            )) }
                        </div>
                    </div>
                    { renderText('span', 'linkText', 'Vidi turu ↗', 'text-link mt-4') }
                </div>
            </CardTag>
        );
    }

    registerBlockType('custom-gutenberg/tour-card', {
        // built-in attributes
        title: 'Tour Card',
        description: 'Offroad or hiking tour card.',
        icon: 'location-alt',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            tourType: { type: 'string', default: 'offroad' },
            image: { type: 'string', default: '' },
            imageId: { type: 'number', default: 0 },
            alt: { type: 'string', default: '' },
            link: { type: 'string', default: '' },
            eyebrow: { type: 'string', default: '' },
            title: { type: 'string', default: '' },
            highlightLabel: { type: 'string', default: 'Izdvojeno' },
            highlight: { type: 'string', default: '' },
            duration: { type: 'string', default: '' },
            durationLabel: { type: 'string', default: 'Trajanje' },
            price: { type: 'string', default: '' },
            priceLabel: { type: 'string', default: 'Cijena' },
            distance: { type: 'string', default: '' },
            distanceLabel: { type: 'string', default: 'Duljina' },
            difficulty: { type: 'string', default: '' },
            difficultyLabel: { type: 'string', default: 'Zahtjevnost' },
            linkText: { type: 'string', default: 'Vidi turu ↗' }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {
            const { tourType, image, imageId, alt, link } = attributes;

            function onSelectImage(image) {
                const full = image.sizes && image.sizes.full;
                setAttributes({ image: full ? full.url : image.url, imageId: image.id, alt: image.alt || '' });
            }

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Tour settings">
                        <SelectControl label="Tour type" value={ tourType } options={ [{ label: 'Offroad', value: 'offroad' }, { label: 'Hike', value: 'hike' }] } onChange={ tourType => setAttributes({ tourType: tourType }) } />
                        <TextControl label="Tour link" value={ link } onChange={ link => setAttributes({ link: link }) } />
                    </PanelBody>
                    <PanelBody title="Image">
                        <MediaUpload
                            onSelect={ onSelectImage }
                            type="image"
                            allowedTypes={ ['image'] }
                            value={ imageId }
                            render={ ({ open }) => (
                                <div>
                                    { image && <figure><img src={ image } alt={ alt } /></figure> }
                                    <Button onClick={ open } className="button">{ image ? 'Replace image' : 'Select image' }</Button>
                                    { image && <Button onClick={ () => setAttributes({ image: '', imageId: 0, alt: '' }) } className="button">Remove image</Button> }
                                </div>
                            ) }
                        />
                        <TextControl label="Image description" value={ alt } onChange={ alt => setAttributes({ alt: alt }) } />
                    </PanelBody>
                </InspectorControls>,
                <div key="preview">{ renderCard(attributes, true, setAttributes) }</div>
            ]);
        },

        save({ attributes }) {
            return renderCard(attributes, false);
        }
    });
}
